import React from 'react'
import { Divider } from 'src/components/common/Divider'
import SearchPopularCoupon from 'src/pages/SearchPage/SearchMainPage/_components/SearchPopularCoupon'
import { SearchMainPageProps } from 'src/pages/SearchPage/SearchMainPage/index'
import RenderIf from 'src/components/common/RenderIf'
import { Typography } from 'src/components/common/Typography'
import { Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { CustomSwiper } from 'src/components/common/CustomSwiper'
import {
  ChipsDefaultStyle,
  ChipsItemsMiddleStyle,
  ChipsItemStyle,
  ChipsListStyle,
} from 'src/components/common/Chips'
import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import useLocalStorage from 'src/hooks/useLocalStorage.hook'

const SearchMainPageView = (props: SearchMainPageProps) => {
  const { isPopularCoupon, isRecentHistory, searchResultPageNavHandler } = props
  const [recentHistory] = useLocalStorage<string[]>('recent_search_history', [])
  return (
    <React.Fragment>
      <RenderIf when={isRecentHistory}>
        <S.SearchRecentHistoryContainer $option="flex_column" $row_gap="12px">
          <S.SearchRecentHistoryPrimaryText>
            <Typography $fontStyle={Noto_subheading_b18}>최근검색어</Typography>
          </S.SearchRecentHistoryPrimaryText>
          <CustomSwiper.Wrap type="default" $wrapstyle={ChipsListStyle(S.ChipsSwiperStyle)} gap={8}>
            {recentHistory?.map((word: string) => (
              <CustomSwiper.Item
                key={word}
                $itemstyle={S.ChipsSwiperItemsStyle}
                onClick={searchResultPageNavHandler}
              >
                {word}
              </CustomSwiper.Item>
            ))}
          </CustomSwiper.Wrap>
        </S.SearchRecentHistoryContainer>
        <Divider />
      </RenderIf>
      <RenderIf when={isPopularCoupon}>
        <SearchPopularCoupon PopularCoupon={props.PopularCoupon} />
      </RenderIf>
    </React.Fragment>
  )
}
export default SearchMainPageView
const S = {
  ChipsSwiperStyle: css`
    position: relative;
    padding: 0 20px;
  `,
  ChipsSwiperItemsStyle: css`
    ${ChipsItemStyle};
    ${ChipsItemsMiddleStyle};
    ${ChipsDefaultStyle()};
    width: auto;
  `,
  SearchRecentHistoryContainer: styled(Container)`
    margin: 30px auto;
  `,
  SearchRecentHistoryPrimaryText: styled(Container)`
    padding: 0 20px;
  `,
}
